import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import { signInWithPopup } from "firebase/auth"
import { auth, provider } from '../firebase'
import propTypes from 'prop-types'

const SignIn = ({ openModal, onHandleClose }) => {
  
  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider)
      const user = result.user
      console.log("Google sign-in success:", user)
      
      onHandleClose()
    } catch (error) {
      console.error("Google sign-in error:", error)
    }
  }

  return (
    <div>
      <Modal
        open={openModal}
        onClose={onHandleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="sign-in-pop-up">
          <Typography className='sign-in-header' id="modal-modal-title" variant="h6" component="h2">
            sign In
          </Typography>
          <Typography className='sign-in-option' id="modal-modal-description" sx={{ mt: 2, mb: 2 }} onClick={handleGoogleSignIn}>
            sign in with google
          </Typography>
        </Box>
      </Modal>
    </div>
  )
}

SignIn.propTypes = {
  openModal: propTypes.bool.isRequired,
  onHandleClose: propTypes.func.isRequired
}

export default SignIn
